import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import API from "../../api";

import * as ActionTypes from '../../constants/ActionTypes';
import * as Actions from '../../actions/seller/seller.appointmentSettings';

function* getAppointmentSettingsSaga(action) {
    try {
        const response = yield call(API.get, `/sellers/appointment-settings`, { withCredentials: true });
        
        // Extract settings from the correct path in response
        const settings = response.data?.settings || response.data || response.settings;
        
        yield put(Actions.getAppointmentSettingsSuccess(settings));
    } catch (error) {
        yield put(Actions.getAppointmentSettingsFailure(error));
    }
}

function* updateAppointmentSettingsSaga(action) {
    try {
        const { settings } = action.payload;
        const response = yield call(
            API.put, 
            `/sellers/appointment-settings`, 
            settings,
            { withCredentials: true }
        );
        
        // Extract settings from the correct path in response
        const updatedSettings = response.data?.settings || response.data || response.settings;
        
        yield put(Actions.updateAppointmentSettingsSuccess(updatedSettings));
    } catch (error) {
        yield put(Actions.updateAppointmentSettingsFailure(error));
    }
}

function* addBlockedDateSaga(action) {
    try {
        const { date, reason } = action.payload;
        const response = yield call(
            API.post,
            `/sellers/appointment-settings/blocked-dates`,
            { date, reason },
            { withCredentials: true }
        );
        
        // Extract blocked dates from the correct path in response
        const blockedDates = response.data?.blocked_dates || response.blocked_dates;
        
        yield put(Actions.addBlockedDateSuccess(blockedDates));
    } catch (error) {
        yield put(Actions.addBlockedDateFailure(error));
    }
}

function* removeBlockedDateSaga(action) {
    try {
        const { date } = action.payload;
        const response = yield call(
            API.delete,
            `/sellers/appointment-settings/blocked-dates`,
            { data: { date }, withCredentials: true }
        );
        
        // Extract blocked dates from the correct path in response
        const blockedDates = response.data?.blocked_dates || response.blocked_dates;
        
        yield put(Actions.removeBlockedDateSuccess(blockedDates));
    } catch (error) {
        yield put(Actions.removeBlockedDateFailure(error));
    }
}

function* getAvailableDatesSaga(action) {
    try {
        const response = yield call(
            API.get,
            `/sellers/appointment-settings/available-dates`,
            { withCredentials: true }
        );
        
        // Extract dates from the correct path in response
        const dates = response.data?.dates || response.data || response.dates;
        
        yield put(Actions.getAvailableDatesSuccess(dates));
    } catch (error) {
        yield put(Actions.getAvailableDatesFailure(error));
    }
}

export default function* appointmentSettingsSaga() {
    yield takeLatest(ActionTypes.GET_APPOINTMENT_SETTINGS_REQUEST, getAppointmentSettingsSaga);
    yield takeEvery(ActionTypes.UPDATE_APPOINTMENT_SETTINGS_REQUEST, updateAppointmentSettingsSaga);
    yield takeEvery(ActionTypes.ADD_BLOCKED_DATE_REQUEST, addBlockedDateSaga);
    yield takeEvery(ActionTypes.REMOVE_BLOCKED_DATE_REQUEST, removeBlockedDateSaga);
    yield takeLatest(ActionTypes.GET_AVAILABLE_DATES_REQUEST, getAvailableDatesSaga);
}
